import React, { PureComponent } from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from "recharts";

export function getColorFromStatus(status) {
  switch (status) {
    case "NO_SIGNAL":
      return "#C03E5A";

    case "HIGH_SIGNAL":
      return "#34D399";

    case "LOW_SIGNAL":
    case "SUSPECT_SIGNAL":
    default:
      return "#F8CD7E";
  }
}

export default class SensePieChart extends PureComponent {
  render() {
    const { score, status, barColor, isLarge } = this.props;

    const color = getColorFromStatus(status);

    const data = [
      {
        name: "G",
        value: score !== undefined ? Number(score) : 0,
        color: barColor !== undefined ? barColor : color
      },
      {
        name: "B",
        value: score !== undefined ? 10 - Number(score) : 10,
        color: "#C8CAD4"
      }
    ];

    return (
      <PieChart width={200} height={200} onMouseEnter={this.onPieEnter}>
        <Pie
          data={data}
          cx={100}
          cy={100}
          startAngle={200}
          endAngle={-20}
          innerRadius={isLarge ? 45 : 30}
          outerRadius={isLarge ? 55 : 40}
          fill="#8884d8"
          paddingAngle={2}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry?.color} />
          ))}
        </Pie>
      </PieChart>
    );
  }
}
